import Vue from 'vue'
import Router from 'vue-router'
import { normalizeURL, decode } from 'ufo'
import { interopDefault } from './utils'
import scrollBehavior from './router.scrollBehavior.js'

const _ce13b52c = () => interopDefault(import('../src/pages/confirmForgotPassword.vue' /* webpackChunkName: "pages/confirmForgotPassword" */))
const _124ab7c3 = () => interopDefault(import('../src/pages/dashboard/index.vue' /* webpackChunkName: "pages/dashboard/index" */))
const _e99ffe3c = () => interopDefault(import('../src/pages/forgotPassword.vue' /* webpackChunkName: "pages/forgotPassword" */))
const _3ae2834d = () => interopDefault(import('../src/pages/forgotPasswordConfirmed.vue' /* webpackChunkName: "pages/forgotPasswordConfirmed" */))
const _a39e44d6 = () => interopDefault(import('../src/pages/login.vue' /* webpackChunkName: "pages/login" */))
const _64fbdd8e = () => interopDefault(import('../src/pages/logout.vue' /* webpackChunkName: "pages/logout" */))
const _ddf76a3c = () => interopDefault(import('../src/pages/onboarding/index.vue' /* webpackChunkName: "pages/onboarding/index" */))
const _2d02d1df = () => interopDefault(import('../src/pages/pmu-concept.vue' /* webpackChunkName: "pages/pmu-concept" */))
const _32e46272 = () => interopDefault(import('../src/pages/pricing.vue' /* webpackChunkName: "pages/pricing" */))
const _9804f9ac = () => interopDefault(import('../src/pages/uitest.vue' /* webpackChunkName: "pages/uitest" */))
const _099b9a1c = () => interopDefault(import('../src/pages/dashboard/campaign/index.vue' /* webpackChunkName: "pages/dashboard/campaign/index" */))
const _8d511b76 = () => interopDefault(import('../src/pages/dashboard/settings/index.vue' /* webpackChunkName: "pages/dashboard/settings/index" */))
const _0f571df0 = () => interopDefault(import('../src/pages/dashboard/settings/index/index.vue' /* webpackChunkName: "pages/dashboard/settings/index/index" */))
const _32756696 = () => interopDefault(import('../src/pages/dashboard/settings/index/branding.vue' /* webpackChunkName: "pages/dashboard/settings/index/branding" */))
const _2b1fe665 = () => interopDefault(import('../src/pages/dashboard/settings/index/domains.vue' /* webpackChunkName: "pages/dashboard/settings/index/domains" */))
const _5f955786 = () => interopDefault(import('../src/pages/dashboard/settings/index/flags.vue' /* webpackChunkName: "pages/dashboard/settings/index/flags" */))
const _6916323a = () => interopDefault(import('../src/pages/dashboard/settings/index/plan.vue' /* webpackChunkName: "pages/dashboard/settings/index/plan" */))
const _7d78f13e = () => interopDefault(import('../src/pages/dashboard/settings/index/privacy.vue' /* webpackChunkName: "pages/dashboard/settings/index/privacy" */))
const _3dbe4b3e = () => interopDefault(import('../src/pages/dashboard/settings/index/users.vue' /* webpackChunkName: "pages/dashboard/settings/index/users" */))
const _4cbc9938 = () => interopDefault(import('../src/pages/dia/galicia1.vue' /* webpackChunkName: "pages/dia/galicia1" */))
const _1bc7efb4 = () => interopDefault(import('../src/pages/profile/create.vue' /* webpackChunkName: "pages/profile/create" */))
const _09acfd55 = () => interopDefault(import('../src/pages/profile/delete.vue' /* webpackChunkName: "pages/profile/delete" */))
const _2ecaeddf = () => interopDefault(import('../src/pages/profile/deleted.vue' /* webpackChunkName: "pages/profile/deleted" */))
const _e8677b44 = () => interopDefault(import('../src/pages/profile/switch.vue' /* webpackChunkName: "pages/profile/switch" */))
const _3ed49543 = () => interopDefault(import('../src/pages/dashboard/campaign/new/index.vue' /* webpackChunkName: "pages/dashboard/campaign/new/index" */))
const _0e7cd71f = () => interopDefault(import('../src/pages/dashboard/campaign/new/index/csat.vue' /* webpackChunkName: "pages/dashboard/campaign/new/index/csat" */))
const _b59561b6 = () => interopDefault(import('../src/pages/dashboard/campaign/new/index/nps.vue' /* webpackChunkName: "pages/dashboard/campaign/new/index/nps" */))
const _3afb3b40 = () => interopDefault(import('../src/pages/dashboard/campaign/new/index/prompt.vue' /* webpackChunkName: "pages/dashboard/campaign/new/index/prompt" */))
const _7c0ebe5b = () => interopDefault(import('../src/pages/dashboard/campaign/new/index/selector.vue' /* webpackChunkName: "pages/dashboard/campaign/new/index/selector" */))
const _db128ce8 = () => interopDefault(import('../src/pages/dashboard/settings/users/new.vue' /* webpackChunkName: "pages/dashboard/settings/users/new" */))
const _36ed8b04 = () => interopDefault(import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */))
const _56f484dd = () => interopDefault(import('../src/pages/dashboard/campaign/_id/index.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/index" */))
const _75e19cc0 = () => interopDefault(import('../src/pages/dashboard/campaign/_id/index/index.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/index/index" */))
const _33c3cd90 = () => interopDefault(import('../src/pages/dashboard/campaign/_id/index/details.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/index/details" */))
const _2046dcf4 = () => interopDefault(import('../src/pages/dashboard/campaign/_id/index/prompt.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/index/prompt" */))
const _59af2723 = () => interopDefault(import('../src/pages/dashboard/campaign/_id/index/voices.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/index/voices" */))
const _68d8fe12 = () => interopDefault(import('../src/pages/dashboard/campaign/_id/edit/index.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/edit/index" */))
const _d0c090f0 = () => interopDefault(import('../src/pages/dashboard/campaign/_id/edit/index/branding.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/edit/index/branding" */))
const _603497b0 = () => interopDefault(import('../src/pages/dashboard/campaign/_id/edit/index/csat.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/edit/index/csat" */))
const _2c4a41c5 = () => interopDefault(import('../src/pages/dashboard/campaign/_id/edit/index/details.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/edit/index/details" */))
const _1baa8f18 = () => interopDefault(import('../src/pages/dashboard/campaign/_id/edit/index/nps.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/edit/index/nps" */))
const _5dc53653 = () => interopDefault(import('../src/pages/dashboard/campaign/_id/edit/index/other.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/edit/index/other" */))
const _b5677a9e = () => interopDefault(import('../src/pages/dashboard/campaign/_id/edit/index/prompt.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/edit/index/prompt" */))
const _79346c82 = () => interopDefault(import('../src/pages/dashboard/campaign/_id/edit/index/thankyou.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/edit/index/thankyou" */))
const _21341e3e = () => interopDefault(import('../src/pages/dashboard/campaign/_id/edit/index/video.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/edit/index/video" */))
const _19daca8c = () => interopDefault(import('../src/pages/dashboard/campaign/_id/graphOptions.js' /* webpackChunkName: "pages/dashboard/campaign/_id/graphOptions" */))
const _f01ca726 = () => interopDefault(import('../src/pages/dashboard/campaign/_id/share/index.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/share/index" */))
const _58d46d30 = () => interopDefault(import('../src/pages/dashboard/campaign/_id/share/index/index.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/share/index/index" */))
const _07591afa = () => interopDefault(import('../src/pages/dashboard/campaign/_id/share/index/email.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/share/index/email" */))
const _34fb37b7 = () => interopDefault(import('../src/pages/dashboard/campaign/_id/share/index/embed.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/share/index/embed" */))
const _223e1a0c = () => interopDefault(import('../src/pages/dashboard/campaign/_id/share/index/link.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/share/index/link" */))
const _3ef90d20 = () => interopDefault(import('../src/pages/dashboard/campaign/_id/share/index/qrcode.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/share/index/qrcode" */))
const _289d597f = () => interopDefault(import('../src/pages/dashboard/campaign/_id/share/index/social.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/share/index/social" */))
const _71ac7aa4 = () => interopDefault(import('../src/pages/dashboard/campaign/_id/share/index/whatsapp.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/share/index/whatsapp" */))
const _f4fd4e54 = () => interopDefault(import('../src/pages/dashboard/campaign/_id/share/index/widget.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/share/index/widget" */))
const _4f36c406 = () => interopDefault(import('../src/pages/dashboard/campaign/_id/upload.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/upload" */))
const _4c0121ea = () => interopDefault(import('../src/pages/dashboard/campaign/_id/voice/_postID/index.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/voice/_postID/index" */))
const _4266803e = () => interopDefault(import('../src/pages/dashboard/campaign/_id/voice/_postID/index/edit.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/voice/_postID/index/edit" */))
const _1df719db = () => interopDefault(import('../src/pages/dashboard/campaign/_id/voice/_postID/index/share.vue' /* webpackChunkName: "pages/dashboard/campaign/_id/voice/_postID/index/share" */))
const _28f674e5 = () => interopDefault(import('../src/pages/onboarding/_profileEditWithCampaignID.vue' /* webpackChunkName: "pages/onboarding/_profileEditWithCampaignID" */))
const _3864ad8b = () => interopDefault(import('../src/pages/_.vue' /* webpackChunkName: "pages/_" */))

const emptyFn = () => {}

Vue.use(Router)

export const routerOptions = {
  mode: 'history',
  base: '/',
  linkActiveClass: 'nuxt-link-active',
  linkExactActiveClass: 'nuxt-link-exact-active',
  scrollBehavior,

  routes: [{
    path: "/confirmForgotPassword",
    component: _ce13b52c,
    name: "confirmForgotPassword"
  }, {
    path: "/dashboard",
    component: _124ab7c3,
    name: "dashboard"
  }, {
    path: "/forgotPassword",
    component: _e99ffe3c,
    name: "forgotPassword"
  }, {
    path: "/forgotPasswordConfirmed",
    component: _3ae2834d,
    name: "forgotPasswordConfirmed"
  }, {
    path: "/login",
    component: _a39e44d6,
    name: "login"
  }, {
    path: "/logout",
    component: _64fbdd8e,
    name: "logout"
  }, {
    path: "/onboarding",
    component: _ddf76a3c,
    name: "onboarding"
  }, {
    path: "/pmu-concept",
    component: _2d02d1df,
    name: "pmu-concept"
  }, {
    path: "/pricing",
    component: _32e46272,
    name: "pricing"
  }, {
    path: "/uitest",
    component: _9804f9ac,
    name: "uitest"
  }, {
    path: "/dashboard/campaign",
    component: _099b9a1c,
    name: "dashboard-campaign"
  }, {
    path: "/dashboard/settings",
    component: _8d511b76,
    children: [{
      path: "",
      component: _0f571df0,
      name: "dashboard-settings-index"
    }, {
      path: "branding",
      component: _32756696,
      name: "dashboard-settings-index-branding"
    }, {
      path: "domains",
      component: _2b1fe665,
      name: "dashboard-settings-index-domains"
    }, {
      path: "flags",
      component: _5f955786,
      name: "dashboard-settings-index-flags"
    }, {
      path: "plan",
      component: _6916323a,
      name: "dashboard-settings-index-plan"
    }, {
      path: "privacy",
      component: _7d78f13e,
      name: "dashboard-settings-index-privacy"
    }, {
      path: "users",
      component: _3dbe4b3e,
      name: "dashboard-settings-index-users"
    }]
  }, {
    path: "/dia/galicia1",
    component: _4cbc9938,
    name: "dia-galicia1"
  }, {
    path: "/profile/create",
    component: _1bc7efb4,
    name: "profile-create"
  }, {
    path: "/profile/delete",
    component: _09acfd55,
    name: "profile-delete"
  }, {
    path: "/profile/deleted",
    component: _2ecaeddf,
    name: "profile-deleted"
  }, {
    path: "/profile/switch",
    component: _e8677b44,
    name: "profile-switch"
  }, {
    path: "/dashboard/campaign/new",
    component: _3ed49543,
    name: "dashboard-campaign-new",
    children: [{
      path: "csat",
      component: _0e7cd71f,
      name: "dashboard-campaign-new-index-csat"
    }, {
      path: "nps",
      component: _b59561b6,
      name: "dashboard-campaign-new-index-nps"
    }, {
      path: "prompt",
      component: _3afb3b40,
      name: "dashboard-campaign-new-index-prompt"
    }, {
      path: "selector",
      component: _7c0ebe5b,
      name: "dashboard-campaign-new-index-selector"
    }]
  }, {
    path: "/dashboard/settings/users/new",
    component: _db128ce8,
    name: "dashboard-settings-users-new"
  }, {
    path: "/",
    component: _36ed8b04,
    alias: "/index.html",
    name: "index"
  }, {
    path: "/dashboard/campaign/:id",
    component: _56f484dd,
    children: [{
      path: "",
      component: _75e19cc0,
      name: "dashboard-campaign-id-index"
    }, {
      path: "details",
      component: _33c3cd90,
      name: "dashboard-campaign-id-index-details"
    }, {
      path: "prompt",
      component: _2046dcf4,
      name: "dashboard-campaign-id-index-prompt"
    }, {
      path: "voices",
      component: _59af2723,
      name: "dashboard-campaign-id-index-voices"
    }]
  }, {
    path: "/dashboard/campaign/:id/edit",
    component: _68d8fe12,
    name: "dashboard-campaign-id-edit",
    children: [{
      path: "branding",
      component: _d0c090f0,
      name: "dashboard-campaign-id-edit-index-branding"
    }, {
      path: "csat",
      component: _603497b0,
      name: "dashboard-campaign-id-edit-index-csat"
    }, {
      path: "details",
      component: _2c4a41c5,
      name: "dashboard-campaign-id-edit-index-details"
    }, {
      path: "nps",
      component: _1baa8f18,
      name: "dashboard-campaign-id-edit-index-nps"
    }, {
      path: "other",
      component: _5dc53653,
      name: "dashboard-campaign-id-edit-index-other"
    }, {
      path: "prompt",
      component: _b5677a9e,
      name: "dashboard-campaign-id-edit-index-prompt"
    }, {
      path: "thankyou",
      component: _79346c82,
      name: "dashboard-campaign-id-edit-index-thankyou"
    }, {
      path: "video",
      component: _21341e3e,
      name: "dashboard-campaign-id-edit-index-video"
    }]
  }, {
    path: "/dashboard/campaign/:id/graphOptions",
    component: _19daca8c,
    name: "dashboard-campaign-id-graphOptions"
  }, {
    path: "/dashboard/campaign/:id/share",
    component: _f01ca726,
    children: [{
      path: "",
      component: _58d46d30,
      name: "dashboard-campaign-id-share-index"
    }, {
      path: "email",
      component: _07591afa,
      name: "dashboard-campaign-id-share-index-email"
    }, {
      path: "embed",
      component: _34fb37b7,
      name: "dashboard-campaign-id-share-index-embed"
    }, {
      path: "link",
      component: _223e1a0c,
      name: "dashboard-campaign-id-share-index-link"
    }, {
      path: "qrcode",
      component: _3ef90d20,
      name: "dashboard-campaign-id-share-index-qrcode"
    }, {
      path: "social",
      component: _289d597f,
      name: "dashboard-campaign-id-share-index-social"
    }, {
      path: "whatsapp",
      component: _71ac7aa4,
      name: "dashboard-campaign-id-share-index-whatsapp"
    }, {
      path: "widget",
      component: _f4fd4e54,
      name: "dashboard-campaign-id-share-index-widget"
    }]
  }, {
    path: "/dashboard/campaign/:id/upload",
    component: _4f36c406,
    name: "dashboard-campaign-id-upload"
  }, {
    path: "/dashboard/campaign/:id/voice/:postID",
    component: _4c0121ea,
    name: "dashboard-campaign-id-voice-postID",
    children: [{
      path: "edit",
      component: _4266803e,
      name: "dashboard-campaign-id-voice-postID-index-edit"
    }, {
      path: "share",
      component: _1df719db,
      name: "dashboard-campaign-id-voice-postID-index-share"
    }]
  }, {
    path: "/onboarding/:profileEditWithCampaignID",
    component: _28f674e5,
    name: "onboarding-profileEditWithCampaignID"
  }, {
    path: "/*",
    component: _3864ad8b,
    name: "all"
  }],

  fallback: false
}

export function createRouter (ssrContext, config) {
  const base = (config._app && config._app.basePath) || routerOptions.base
  const router = new Router({ ...routerOptions, base  })

  // TODO: remove in Nuxt 3
  const originalPush = router.push
  router.push = function push (location, onComplete = emptyFn, onAbort) {
    return originalPush.call(this, location, onComplete, onAbort)
  }

  const resolve = router.resolve.bind(router)
  router.resolve = (to, current, append) => {
    if (typeof to === 'string') {
      to = normalizeURL(to)
    }
    return resolve(to, current, append)
  }

  return router
}
